function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* globals window */

import { capitalize, flatten } from '../helpers';
import convertPxToRem from '../convertPxToRem';
export var EXTRA_MARGIN = 8;
export var positionSet = {
  tooltip: [['top', 'bottom'], ['left', 'right']],
  popup: [['topRight', 'bottomRight'], ['topLeft', 'bottomLeft']]
};
export var getPositionLimits = function getPositionLimits(parent, child) {
  var hasSpaceTop = parent.top > child.height + parent.height;
  var hasSpaceBottom = window.innerHeight - parent.bottom > child.height + parent.height;
  var hasSpaceLeft = parent.left > child.width;
  var hasSpaceRight = window.innerWidth - parent.right > child.width;
  var hasSpaceTopRight = parent.top > child.height + parent.height && parent.left > child.width - parent.width;
  var hasSpaceTopLeft = parent.top > child.height + parent.height && window.innerWidth - parent.right > child.width - parent.width;
  var hasSpaceBottomRight = window.innerHeight - parent.bottom > child.height && parent.left > child.width - parent.width;
  var hasSpaceBottomLeft = window.innerHeight - parent.bottom > child.width && window.innerWidth - parent.right > child.width - parent.width;
  return {
    hasSpaceTop: hasSpaceTop,
    hasSpaceBottom: hasSpaceBottom,
    hasSpaceLeft: hasSpaceLeft,
    hasSpaceRight: hasSpaceRight,
    hasSpaceTopRight: hasSpaceTopRight,
    hasSpaceTopLeft: hasSpaceTopLeft,
    hasSpaceBottomRight: hasSpaceBottomRight,
    hasSpaceBottomLeft: hasSpaceBottomLeft
  };
};
export var offsetPriority = function offsetPriority(side) {
  var isTooltip = flatten(positionSet.tooltip).indexOf(side) > -1;
  var type = isTooltip ? 'tooltip' : 'popup';
  var groupX = _toConsumableArray(positionSet[type][0]);
  var groupY = _toConsumableArray(positionSet[type][1]);
  groupX = groupX.indexOf(side) === groupX.length - 1 ? groupX.reverse() : groupX;
  groupY = groupY.indexOf(side) === groupY.length - 1 ? groupY.reverse() : groupY;
  return [].concat(_toConsumableArray(groupX.indexOf(side) > -1 ? groupX : groupY), _toConsumableArray(groupY.indexOf(side) > -1 ? groupX : groupY), _toConsumableArray(isTooltip ? flatten(positionSet.popup) : flatten(positionSet.tooltip)));
};
export var whereToRender = function whereToRender(parent, child, side, fallbackRenderSide) {
  var renderAbility = getPositionLimits(parent, child);
  var sidePriority = offsetPriority(side);
  var preferedRenderSide = sidePriority.find(function (item) {
    return renderAbility["hasSpace".concat(capitalize(item))];
  });
  return preferedRenderSide || fallbackRenderSide;
};

// This function returns the height that the popUp could have
export var getHeighForStaticToolTip = function getHeighForStaticToolTip(parent, isStatic) {
  var side = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (isStatic) {
    switch (side) {
      case 'bottom':
      case 'bottomLeft':
      case 'bottomRight':
        return convertPxToRem(window.innerHeight - parent.getBoundingClientRect()[side] - 20);
      case 'top':
      case 'topRight':
      case 'topLeft':
        return convertPxToRem(parent.getBoundingClientRect()[side] - 20);
      default:
        return convertPxToRem(parent.getBoundingClientRect().bottom - parent.clientHeight);
    }
  }
  return 'auto';
};